import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';
import { actions } from '../../shared/store.js';

import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import WhatIsOpenInnovationService from './what-is-open-innovation.service.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './what-is-open-innovation.scss';

class WhatIsOpenInnovationPage extends Component {
	static prefetchData = async language => WhatIsOpenInnovationService.getPageData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.whatIsOpenInnovationPageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (this.props.language.value !== prevProps.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		WhatIsOpenInnovationPage.prefetchData(this.props.language.value)
			.then((data) => {
				this.props.setWhatIsOpenInnovationn(data);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const { whatIsOpenInnovationPageData, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return <NotImplemented title="What Is Open Innovation?" />;
		}

		return (
			<section className="what-is-open-innovation">
				<Seo
					title={formatMessage({ id: 'navigation.about.whatIsOpenInnovation' })}
					description={(whatIsOpenInnovationPageData && whatIsOpenInnovationPageData.description) || formatMessage({ id: 'navigation.about.whatIsOpenInnovation' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "QAPage",
											"mainEntity": {
												"@type": "Question",
												"name": "${whatIsOpenInnovationPageData && whatIsOpenInnovationPageData.title}",
												"answerCount": 1,
												"acceptedAnswer": {
													"@type": "Answer",
													"text": "${whatIsOpenInnovationPageData && whatIsOpenInnovationPageData.description}",
													"author": "${whatIsOpenInnovationPageData && whatIsOpenInnovationPageData.author}"
												}
											}
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.whatIsOpenInnovation' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/what-is-open-innovation"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid">
					<div className="section intro row">
						{whatIsOpenInnovationPageData
							&& (
								<div className="section col col-lg-12 col-md-12 col-sm-12 col-xs-12 title">
									{whatIsOpenInnovationPageData.title}
								</div>
							)
						}
						{whatIsOpenInnovationPageData
							&& (
								<div className="section col col-lg-12 col-md-12 col-sm-12 col-xs-12 subtitle">
									{whatIsOpenInnovationPageData.description}
								</div>
							)
						}
						{whatIsOpenInnovationPageData
						&& (
							<div className="section col col-lg-12 col-md-12 col-sm-12 col-xs-12 author">
								{whatIsOpenInnovationPageData.author}
							</div>
						)
						}
					</div>
				</div>
			</section>
		);
	}
}

const mapToProps = ({ language, whatIsOpenInnovationPageData, addresses, phones, generalData }) => ({
	language,
	whatIsOpenInnovationPageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(WhatIsOpenInnovationPage));

export { WhatIsOpenInnovationPage };
